import { CHAIN } from '@/utils/constants';
import { storageUsageAPI } from '@/utils/get-storage';
import { KeyStoreInstance } from '@/utils/identity-utils/key-store';
import { AgentInstance } from '@/utils/identity-utils/smart-account-agent';
import { useQuery } from '@tanstack/react-query';
import { Hex } from 'viem';

export interface IPortalStorage {
  limit: number;
  storageUsed: number;
  usedStoragePercentage: number;
  contractAddress: string;
}

const usePortalStorage = (isReady: boolean) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['FETCH_PORTAL_STORAGE'],
    queryFn: async () => {
      if (!isReady) return null;
      const contractAddress = KeyStoreInstance.portalAddress;
      const editSecret = KeyStoreInstance.editSecret;
      const invoker = AgentInstance.getAgentAddress();
      const chain = CHAIN.id;

      if (!contractAddress || !editSecret || !invoker || !chain) {
        return null;
      }
      return storageUsageAPI({
        contractAddress,
        editSecret,
        invoker,
        chain,
      });
    },
    enabled: isReady,
  });

  const limit = Number(data?.storageLimit ?? 0) / 1000000;
  const inUse = Number(data?.storageUse ?? 0) / 1000000;
  const storage = {
    limit,
    storageUsed: inUse,
    usedStoragePercentage: limit > 0 ? (inUse / limit) * 100 : 0,
    contractAddress: KeyStoreInstance.portalAddress as Hex,
  };

  return { storage, isLoading, error };
};

export { usePortalStorage };
